import React from 'react';

import StaticPageLayout from './StaticPageLayout';

const PressNews = () => (
  <StaticPageLayout
    eyebrow='Newsroom'
    title='Press & News'
    intro='Announcements, milestones and stories from the Evento community. For interviews or media enquiries, get in touch with our team.'
    sections={[
      {
        heading: 'Latest updates',
        paragraphs: [
          'Evento launches a redesigned experience — A refreshed, faster interface makes it easier than ever for clients to discover professionals and for partners to manage their listings.',
          'Category browsing gets smarter — Clients can now explore professionals by category with clear icons, search and a dedicated categories page.',
          'Growing the professional network — More photographers, decorators, caterers, DJs and makeup artists are joining Evento every week across Sri Lanka.',
        ],
      },
      {
        heading: 'Media resources',
        paragraphs: [
          'Journalists and content creators can request our brand assets, logos and approved imagery. Please include your outlet and intended use in your request.',
        ],
      },
      {
        heading: 'Press contact',
        paragraphs: [
          'For press enquiries, partnerships with media, or interview requests, email press@evento.lk and our team will get back to you promptly.',
        ],
      },
    ]}
  />
);

export default PressNews;
